// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/dashboard_background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colors SustainGrowth 

Green 01 - #E6E9B1 - Background
Green 02 - #6F7123 - H3
Green 03 - #9AB82F - Button Hover
Green 04 - #64A555 - Button
Green 05 - #4C7E43 - H1 / H2

*/

/* -- Global Styles Reset -- */

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
}

/* -- Body -- */

body {
    min-height: 100vh;
    background-color: #F8F9EF;
    position: relative;
    z-index: 1;
}

body::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
    opacity: 0.5;
    z-index: -1;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0;}
input[type="number"] {-moz-appearance: textfield;}

/* Headings */

h1 {
    font-size: 2rem;
    color: #4C7E43;
    text-align: center;
    margin: 40px 20px;
}

h2 {
    font-size: 1.7rem;
    font-weight: 700;
    text-align: center;
    color: #4C7E43;
    margin: 20px 0;
}

h3 {
    font-size: 1.4rem;
    font-weight: 700;
    text-align: center;
    color: #6F7123;
    margin: 20px 0;
}

h4 {
    font-size: 1.2rem;
    font-weight: 600;
    text-align: center;
    color: #333;
    margin: 20px 0;
}

p {
    font-size: 1rem;
    color: #333;
    text-align: center;
}

/* Buttons */

.btn,
.btn-save-edit,
.btn-add {
    width: 100%;
    background: #64A555;
    outline: 0;
    border: 0;
    border-radius: 100px;
    color: #FFF;
    font-size: 1.1rem;
    font-weight: 600;
    text-decoration: none;
    padding: 10px 20px;
    cursor: pointer;
}

.btn-upload {
    width: 100%;
    background: #333;
    outline: 0;
    border: 0;
    border-radius: 100px;
    color: #FFF;
    font-size: 1.1rem;
    font-weight: 600;
    text-decoration: none;
    padding: 10px 20px;
    cursor: pointer;
}

.btn i,
.btn-save-edit i,
.btn-upload i,
.btn-add i {
    font-size: 1rem;
    padding-left: 10px
}

.btn:hover,
.btn-save-edit:hover,
.btn-upload:hover,
.btn-add:hover {
    color: #FFF;
    background: #9AB82F;
}`, "",{"version":3,"sources":["webpack://./src/css/sg-platform.css"],"names":[],"mappings":"AAAA;;;;;;;;CAQC;;AAID,8BAA8B;;AAE9B;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA,eAAe;;AAEf;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oEAAsE;IACtE,YAAY;IACZ,WAAW;AACf;;AAEA;kDACkD,wBAAwB,EAAE,SAAS,CAAC;AACtF,sBAAsB,0BAA0B,CAAC;;AAEjD,aAAa;;AAEb;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA,YAAY;;AAEZ;;;IAGI,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;;;IAII,eAAe;IACf;AACJ;;AAEA;;;;IAII,WAAW;IACX,mBAAmB;AACvB","sourcesContent":["/* Colors SustainGrowth \n\nGreen 01 - #E6E9B1 - Background\nGreen 02 - #6F7123 - H3\nGreen 03 - #9AB82F - Button Hover\nGreen 04 - #64A555 - Button\nGreen 05 - #4C7E43 - H1 / H2\n\n*/\n\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');\n\n/* -- Global Styles Reset -- */\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: 'Poppins', sans-serif;\n}\n\n/* -- Body -- */\n\nbody {\n    min-height: 100vh;\n    background-color: #F8F9EF;\n    position: relative;\n    z-index: 1;\n}\n\nbody::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: url('../assets/dashboard_background.png') no-repeat center;\n    opacity: 0.5;\n    z-index: -1;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0;}\ninput[type=\"number\"] {-moz-appearance: textfield;}\n\n/* Headings */\n\nh1 {\n    font-size: 2rem;\n    color: #4C7E43;\n    text-align: center;\n    margin: 40px 20px;\n}\n\nh2 {\n    font-size: 1.7rem;\n    font-weight: 700;\n    text-align: center;\n    color: #4C7E43;\n    margin: 20px 0;\n}\n\nh3 {\n    font-size: 1.4rem;\n    font-weight: 700;\n    text-align: center;\n    color: #6F7123;\n    margin: 20px 0;\n}\n\nh4 {\n    font-size: 1.2rem;\n    font-weight: 600;\n    text-align: center;\n    color: #333;\n    margin: 20px 0;\n}\n\np {\n    font-size: 1rem;\n    color: #333;\n    text-align: center;\n}\n\n/* Buttons */\n\n.btn,\n.btn-save-edit,\n.btn-add {\n    width: 100%;\n    background: #64A555;\n    outline: 0;\n    border: 0;\n    border-radius: 100px;\n    color: #FFF;\n    font-size: 1.1rem;\n    font-weight: 600;\n    text-decoration: none;\n    padding: 10px 20px;\n    cursor: pointer;\n}\n\n.btn-upload {\n    width: 100%;\n    background: #333;\n    outline: 0;\n    border: 0;\n    border-radius: 100px;\n    color: #FFF;\n    font-size: 1.1rem;\n    font-weight: 600;\n    text-decoration: none;\n    padding: 10px 20px;\n    cursor: pointer;\n}\n\n.btn i,\n.btn-save-edit i,\n.btn-upload i,\n.btn-add i {\n    font-size: 1rem;\n    padding-left: 10px\n}\n\n.btn:hover,\n.btn-save-edit:hover,\n.btn-upload:hover,\n.btn-add:hover {\n    color: #FFF;\n    background: #9AB82F;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
